import _ from 'lodash'

export default function declineOrderConfirmation(props = {}) {
  const t = _.get(props, 't')
  const onContinue = _.get(props, 'onContinue')
  const onCancel = _.get(props, 'onCancel')
  return {
    title: t('ui.paymentInProgressModal.title'),
    message: t('ui.paymentInProgressModal.description'),
    buttons: _.compact([
      {
        text: t('ui.paymentInProgressModal.buttons.cancel'),
        onClick: onCancel,
      },
      {
        text: t('ui.paymentInProgressModal.buttons.declineOrder'),
        onClick: onContinue,
      },
    ]),
  }
}
